import { createFeatureSelector } from '@ngrx/store';
import { BUYER_HEADER_FEATURE_NAME } from './feature-name';

export const getBuyerState = createFeatureSelector(BUYER_HEADER_FEATURE_NAME);
